'use client'

import { motion, Variants } from 'framer-motion';

import Form from '../ui/Form';
import { CalButton } from '../ui/CalEmbed';
import { HubSpotMeetings, HUBSPOT_MEETINGS_LINK } from '../ui/HubSpotMeetings';
import { ParagraphSection } from '@/types/drupal';

const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.8, ease: [0.21, 0.47, 0.32, 0.98] } 
  }
};

export default function Contact({ data, lang }: { data: ParagraphSection, lang: string }) {
  const bgImage = data.image?.mediaImage;
  const CONTACT_FORM_MACHINE_NAME = 'contact'; 

  return (
    <section
      id="contact"
      className="Contact py-7.5 overflow-hidden"
      style={{ '--bg-contact-image': bgImage ? `url("${bgImage.url}")` : 'none' } as React.CSSProperties}
      aria-label="Contact"
    >
      <div className="site-container lg:border-t lg:border-b lg:border-[#D9D9D9]">
        <div className="relative bg-[#000115] overflow-hidden">
          <div aria-hidden="true" className="absolute inset-0 z-0 hidden lg:block pointer-events-none select-none bg-(image:--bg-contact-image) bg-size-[55%_auto] bg-position-[right_center] bg-no-repeat opacity-100" />
          <div aria-hidden="true" className="absolute inset-0 z-1 hidden lg:block pointer-events-none bg-linear-to-r from-[#000115] from-40% via-[#000115]/80 via-50% to-transparent" />

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="section-container relative z-10 py-15 lg:py-27.5 flex flex-col items-center lg:items-start"
          >
            <motion.div
              variants={fadeInUp}
              className="Contact__heading max-w-107.5 text-center lg:text-left"
              dangerouslySetInnerHTML={{ __html: data.title?.processed || '' }}
            />

            <motion.div
              variants={fadeInUp}
              className="mt-10 lg:mt-15 w-full max-w-152.5"
            >
              <Form
                formId={CONTACT_FORM_MACHINE_NAME}
                submitLabel={lang === 'es' ? 'HABLEMOS' : "LET'S TALK"}
                theme="dark"
                lang={lang}
              />
            </motion.div>

            <motion.div variants={fadeInUp} className="mt-6 flex items-center gap-4">
              <span className="text-white/40 text-sm">{lang === 'es' ? 'o' : 'or'}</span>
              {/* HubSpot Meetings once NEXT_PUBLIC_HUBSPOT_MEETINGS_LINK is set;
                  falls back to Cal.com until then for zero-downtime migration. */}
              {HUBSPOT_MEETINGS_LINK ? (
                <HubSpotMeetings
                  label={lang === 'es' ? 'Agenda una llamada directa' : 'Book a Discovery Call'}
                  className="text-white/80 text-sm underline underline-offset-4 hover:text-white transition-colors cursor-pointer"
                />
              ) : (
                <CalButton
                  label={lang === 'es' ? 'Agenda una llamada directa' : 'Book a Discovery Call'}
                  className="text-white/80 text-sm underline underline-offset-4 hover:text-white transition-colors cursor-pointer"
                />
              )}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
